import { render } from "./ProductsBulkUpload.vue?vue&type=template&id=b0aecd90&scoped=true"
import script from "./ProductsBulkUpload.vue?vue&type=script&lang=js"
export * from "./ProductsBulkUpload.vue?vue&type=script&lang=js"

import "./ProductsBulkUpload.vue?vue&type=style&index=0&id=b0aecd90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0aecd90"]])

export default __exports__